import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaUser, FaSignOutAlt, FaTachometerAlt } from 'react-icons/fa';

const Navbar = ({ isHomePage }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const active = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link to="/" className="navbar-logo">Portfolio</Link>
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span><span></span><span></span>
        </button>
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" className={active('/')} onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/about" className={active('/about')} onClick={() => setMenuOpen(false)}>About</Link>
          <Link to="/services" className={location.pathname.startsWith('/services') ? 'active' : ''} onClick={() => setMenuOpen(false)}>Services</Link>
          <Link to="/projects" className={active('/projects')} onClick={() => setMenuOpen(false)}>Projects</Link>
          <Link to="/resume" className={active('/resume')} onClick={() => setMenuOpen(false)}>Resume</Link>
          <Link to="/blog" className={location.pathname.startsWith('/blog') ? 'active' : ''} onClick={() => setMenuOpen(false)}>Blog</Link>
          <Link to="/contact" className={active('/contact')} onClick={() => setMenuOpen(false)}>Contact</Link>

          {user ? (
            <>
              <Link to={isAdmin ? '/admin' : '/dashboard'} className="btn btn-outline btn-small" onClick={() => setMenuOpen(false)}>
                <FaTachometerAlt /> Dashboard
              </Link>
              <button onClick={() => { logout(); setMenuOpen(false); }} className="btn btn-small" style={{ background: 'transparent', color: 'var(--secondary)', border: 'none', cursor: 'pointer' }}>
                <FaSignOutAlt />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-outline btn-small" onClick={() => setMenuOpen(false)}><FaUser /> Login</Link>
              <Link to="/register" className="btn btn-primary btn-small" onClick={() => setMenuOpen(false)}>Sign Up</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
